import { RefreshCw } from 'lucide-react'
import { useQueryClient, useIsFetching } from '@tanstack/react-query'
import { Button } from '@/components/ui/button'
import { AlertMailbox } from '@/components/alerts/AlertMailbox'
import type { AlertRow } from '@/api/types'

interface HeaderProps {
  title: string
  description?: string
  children?: React.ReactNode
  alerts?: AlertRow[]
  onAcknowledgeAlert?: (id: string) => void
}

export function Header({ title, description, children, alerts = [], onAcknowledgeAlert }: HeaderProps) {
  const queryClient = useQueryClient()
  const isFetching = useIsFetching()

  return (
    <header className="sticky top-0 z-40 flex h-14 items-center justify-between border-b bg-background/95 px-6 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div>
        <h1 className="text-lg font-semibold">{title}</h1>
        {description && <p className="text-sm text-muted-foreground">{description}</p>}
      </div>
      <div className="flex items-center gap-2">
        {children}
        <AlertMailbox alerts={alerts} onAcknowledge={onAcknowledgeAlert} />
        <Button
          variant="ghost"
          size="icon"
          onClick={() => queryClient.invalidateQueries()}
          disabled={isFetching > 0}
        >
          <RefreshCw className={isFetching > 0 ? 'animate-spin' : ''} />
        </Button>
      </div>
    </header>
  )
}
